import { render, staticRenderFns } from "./CardNotificationContest.vue?vue&type=template&id=26f65800&"
import script from "./CardNotificationContest.vue?vue&type=script&lang=js&"
export * from "./CardNotificationContest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports